export default {
    carLists: [
        {
            label: '服务平台',
            value: 'siteName',
            width: 120
        },
        {
            label: '车次号',
            value: 'trainNum',
            width: 180
        },
        {
            label: '推荐车型',
            value: 'truckModel',
            width: 100
        },
        {
            label: '订单数',
            value: 'orderNum',
            width: 100
        },
        {
            label: '方数(m³)',
            value: 'volume',
            width: 100
        },
        {
            label: '里程(km)',
            value: 'mileage',
            width: 100
        },
        {
            label: '串点数',
            value: 'pointNum',
            width: 100
        },
    ],
    orderLists: [
        {
            label: '分公司',
            value: 'companyName',
            width: 100
        },
        {
            label: '服务平台',
            value: 'siteName',
            width: 120
        },
        {
            label: '客户订单号',
            value: 'customerOrderNo',
            width: 120
        },
        {
            label: '运输单号',
            value: 'taskNo',
            width: 170
        },
        {
            label: '方数(m³)',
            value: 'totalVolume',
            width: 80
        },
        {
            label: '是否限行',
            value: 'restrictFlagName',
            width: 80
        },
        {
            label: '车次号',
            value: 'trainNum',
            width: 150
        },
        {
            label: '客户',
            value: 'customerName',
            width: 180
        },
        {
            label: '收货地址',
            value: 'receiverDetailAddr',
            width: 300
        }
    ]
};
